import React from 'react';
import { motion } from 'framer-motion';
import './ProductList.css';

const ProductList = ({ products }) => {
  return (
    <motion.section
      className="product-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      aria-label="Product List"
    >
      {products.length === 0 ? (
        <p className="no-product">No products found.</p>
      ) : (
        <div className="product-grid">
          {products.map((product, index) => (
            <article key={index} className="product-card">
              <img
                src={product.image}
                alt={product.name || 'Product Image'}
                className="product-image"
                loading="lazy"
                decoding="async"
              />
              <h3 className="product-title">{product.name}</h3>
              <p className="product-desc">{product.description}</p>
              <p className="product-specs">
                <strong>Specs:</strong> {product.specs}
              </p>
            </article>
          ))}
        </div>
      )}
    </motion.section>
  );
};

export default ProductList;
